import { Component } from '@angular/core';
import { WebOrderService } from '../../services/web-order.service';
import { ToasterService } from "../../../../common/services/toaster.service";
@Component({
  selector: 'app-image-upload-page',
  templateUrl: 'image-upload.page.html',
  styleUrls: [
    './image-upload.page.scss',
  ]
})
export class ImageUploadPage {
  loading:boolean=true ;
  selectedFile: File | null = null;
 previewUrl: string | ArrayBuffer | null = null;
    constructor(
    private webOrderService:WebOrderService,
        private toasterService: ToasterService
      ) { 
  
    }
 ngOnInit() {
   
  }
  
onFileSelected(event: any) {
  const file = event.target.files[0];
  if (file) {
    this.selectedFile = file;

    const reader = new FileReader();
    reader.onload = e => this.previewUrl = reader.result;
    reader.readAsDataURL(file);
  }
}

async submitForm():Promise<void> {
  this.loading=false;
  if (!this.selectedFile) {
   this.toasterService.presentToast(
          "danger",
          `Please select image to upload.`,
          "Error"
        );
     this.loading=true;
    return;
  }
  const allowedExtensions = ['jpg', 'gif'];
  const fileName = this.selectedFile.name;
  const fileExt = fileName.split('.').pop()?.toLowerCase();

  if (!fileExt || !allowedExtensions.includes(fileExt)) {
    this.toasterService.presentToast(
      "danger",
      "Only .jpg and .gif files are allowed to upload.",
      "Invalid File Type"
    );
   
    this.loading = true;
    return;
  }

try {
    const response = await this.webOrderService.imageUpload(this.selectedFile);
    if (response === 'Success') {
      this.toasterService.presentToast(
        "primary",
        "Image uploaded successfully.",
        "Success"
      );
    } else {
      this.toasterService.presentToast(
        "danger",
        "Error uploading image.",
        "Error"
      );
    }
  } catch (error) {
    this.toasterService.presentToast(
      "danger",
      "An error occurred while uploading.",
      "Error"
    );
  }

  this.loading = true;
 }
}
 